var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCleaning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.3 19.9c0-.4.3-.7.7-.7h7.8c.4 0 .7.3.7.7v1.7h-9.2zM19.9 5v14M15.3 21.6c0 4.6-3.8 12.3-3.8 12.3 0 .6.5 1.1 1.1 1.1h1.9c1.8-2.4 3.2-6.6 3.2-6.6.2 3.3-.2 5.4-.7 6.6h2.3c.6-1.3 1.5-2.3 1.5-2.3V35h2.7c-.2-1.1-.3-2.6-.2-4.5 0 0 .8 2.3 1.9 4.5H27c.6 0 1.1-.5 1.1-1.1 0 0-3.8-7.7-3.8-12.3"
}))));
export default SvgCleaning;